import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";
import { ManualServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Organisation States Master section
 */
const useListManual = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["manual-list", page_no], ManualServices.manualList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddManual = (onSuccess, onError = onDefaultError) => {
  return useMutation(ManualServices.addManual, {
    onSuccess,
    onError,
  });
};
const useUpdateManual = (onSuccess, onError = onDefaultError) => {
  return useMutation(ManualServices.updateManual, {
    onSuccess,
    onError,
  });
};
const useViewManual = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("manual-view", () => ManualServices.viewManual({ id }), {
    onSuccess,
    onError,
  });
};
const useManualDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(ManualServices.deleteManual, {
    onSuccess,
    onError,
  });
};
const useManualDeletePdfIT = (onSuccess, onError = onDefaultError) => {
  return useMutation(ManualServices.deleteManualPdfIT, {
    onSuccess,
    onError,
  });
};
const useManualDeletePdfDE = (onSuccess, onError = onDefaultError) => {
  return useMutation(ManualServices.deleteManualPdfDE, {
    onSuccess,
    onError,
  });
};
export {
  useListManual,
  useAddManual,
  useViewManual,
  useManualDelete,
  useUpdateManual,
  useManualDeletePdfIT,
  useManualDeletePdfDE,
};
